<template>
  <div>
    <div class="football-credit-variation">
      <div v-if="credits && credits.grouped">
        <div class="title-and-tools">
          <div class="tools">
            <button class="clean full symbol-btn workflow" @click="isView = !isView">↕</button>
          </div>
          <h2 @click="hideBox = !hideBox" class="clickable">
          <span v-if="hideBox">-</span><span v-else>+</span>
          {{title}}</h2>
        </div>
        <div v-if="hideBox">
          <div
            class="page-space player-credits"
            v-for="role in credits.grouped"
            v-if="roleHasPlayers(role.players)"
            :key="role.name">
            <h5 class="bottom-space">{{role.name}}</h5>
            <div class="boxes keep-left" v-if="isView">
              <div v-for="(playerKey, index) in role.players" :key="playerKey">
                <div v-if="credits.players[playerKey].fantasyCredit.credit_src === creditSource">
                  <div class="box player-box  filled min-width">
                    <div class="clickable head"
                      @click="onPlayerSelected(playerKey)">{{credits.players[playerKey].name}}</div>
                    <template>
                      <div class="boxes compact width30 big-numbers">
                        <div><div class="highlight">{{credits.players[playerKey].fantasyCredit.credits | locale}}</div><label>Credit</label></div>
                        <div><div>{{credits.players[playerKey].fantasyCredit.rank | locale}}</div><label>Rank</label></div>
                        <div><div>{{credits.players[playerKey].fantasyCredit.score | locale}}</div><label>Score</label></div>
                      </div>
                      <div class="sub-head">Recent Points</div>
                      <div class="boxes compact">
                        <div class="max-240">
                          <span
                          class="silent"
                          v-for="(prevPoints, index) in credits.players[playerKey].fantasyCredit.prev_points" :key="index"
                          ><router-link
                            class="clean colored tag"
                            :to="{name:'match', params:{key:prevPoints.match_key}}">{{prevPoints.points | locale}}</router-link>
                          </span>
                        </div>
                      </div>
                    </template>
                    <div class="foot">
                      <!-- <button v-if="title == 'Static Credit Points'" class="clean box remove" @click="removePlayerList(playerKey)">Remove</button> -->
                      <button class="blue"
                        @click="editPoints(playerKey, index)">CHANGE CREDIT POINT</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isView" class="credit-table space-15">
              <div class="stats-table maxwidth left">
                <table class="small-size-on-mobile">
                  <thead class="sumrow">
                    <td></td>
                    <td>Name</td>
                    <td>Credit</td>
                    <td class="hide-on-mobile">Rank</td>
                    <td class="hide-on-mobile">Score</td>
                    <td class="hide-on-mobile">Recent Points</td>
                  </thead>
                  <tbody v-for="(playerKey, index) in role.players" :key="playerKey">
                    <tr v-if="credits.players[playerKey].fantasyCredit.credit_src === creditSource">
                      <td>
                        <button class="blue color edit"
                          @click="editPoints(playerKey, index)">CHANGE CREDIT POINT</button>
                      </td>
                      <td class="clickable" @click="onPlayerSelected(playerKey)"><span class="player-name">{{credits.players[playerKey].name}}</span></td>
                      <td>{{credits.players[playerKey].fantasyCredit.credits | locale}}</td>
                      <td class="hide-on-mobile">{{credits.players[playerKey].fantasyCredit.rank | locale('-')}}</td>
                      <td class="hide-on-mobile">{{credits.players[playerKey].fantasyCredit.score | locale}}</td>
                      <td>
                        <!-- <div class="max-240"> -->
                          <span
                          class=""
                          v-for="(prevPoints, index) in credits.players[playerKey].fantasyCredit.prev_points" :key="index"
                          ><router-link
                            class="clean colored tag"
                            :to="{name:'match', params:{key:prevPoints.match_key}}">{{prevPoints.points | locale}}</router-link>.
                          </span>
                        <!-- </div> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="freezen-btn-info" v-if="title == 'Intelligent Dynamic Credit Value'">
          <button class="freezen blue" @click="selectAllPlayers">Convert All Players Credit Points To Static</button>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
import { AppState, DataState } from '@/state'
export default {
  props: {
    credits: Object,
    isFrozen: null,
    title: String,
    creditSource: String,
  },
  data () {
    return {
      state: DataState.newLoading(),
      hideBox: true,
      isView: false,
      dailogPacket: {
        show: false
      },
    }
  },
  mounted () {
  },
  methods: {
    selectAllPlayers () {
      this.$emit('selectAllPlayers')
    },
    editPoints (playerkey, index) {
      this.$emit("editPoints", playerkey, index)
    },
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    removePlayerList (playerKey) {
      this.$emit("removePlayer", playerKey)
    },
    roleHasPlayers (players) {
      for (let playerkey in players) {
        if (this.credits.players[players[playerkey]].fantasyCredit.credit_src == this.creditSource) {
          return true
        }
      }
      return false
    }, 
  }
}
</script>

